/* eslint-disable react-hooks/exhaustive-deps */
import { Fragment, useEffect, useState } from "react"
import { Color, ID } from "src/libs/interfaces/layouts"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { CSSObjectToString, getCssDemention } from "src/libs/utilities"
import { ALIGN, ILanding, ILandingSection } from "src/modules/pe-landing-module/data/interfaces"
import { useComposition } from "src/modules/pe-landing-module/hooks/useComposition"
import { IDataComponentsProps } from "../DataComponents"
import { setHorizontalAlignToCSSRule } from "../Section"
import HAccordeonSection from "./HAccordeonSection"
import usePosition from "src/modules/pe-landing-module/hooks/usePosition"
import chroma from 'chroma-js'
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"

/* Protopia Ecosystem component */
export interface ISectionHAccordeonProps extends IDataComponentsProps {
   
}
const SectionHAccordeon = (props: ISectionHAccordeonProps): JSX.Element => {
    const setColors = (): Color[] => {
        const colors = section.haccordeon_design?.isNoBackground
            ?
            [  "#FFFFFF00", "#FFFFFF00"  ]
            :
            section.haccordeon_design?.cardColors || section.cardColors || ["#e1e1e1", "#6b6b6b"]
        return chroma.scale( colors ).colors(props.data.length)
    }
    
    const [section, setSection] = useState<ILandingSection>(props.section)    
    useEffect(() => {
        const unsubscribe = useLandingStore.subscribe(
            ( state: ILandingStore ) => state.currentLanding,
            ( currentLanding:ILanding ) => { 
                const sec: ILandingSection = currentLanding.sections.find(s => s.id === props.section.id)!                            
                if( JSON.stringify( sec ) !== JSON.stringify( section ) ) { 
                    setSection(() => {
                        return sec
                    })
                }
            }, 
            {} 
        )
        return () => {
            unsubscribe();
        };
    }, [])  
    const composition = useComposition( section )
    const position = usePosition(section).position
    const [accOpen, setAccOpen] = useState<ID>() 
    const [cardsColor, setCardsColor] = useState<Color[]>( setColors() ) 
    const [wdt, setWdt] = useState<number>(0)
    const [cpWdt, setClWdt] = useState<string>("")

    const COVER_WIDTH = 100

    useEffect(() => {
        setCardsColor( setColors() )
    }, [props.data, section.cardColors])

    useEffect(() => {
        const cw            = section.haccordeon_design?.cover_width ? section.haccordeon_design?.cover_width : COVER_WIDTH
        const cover_width   = `width: ${cw}px!important;
            min-width: ${cw}px!important;
            max-width: ${cw}px!important; ` 
        const width = document.querySelector(`.landing-section-container.landing-gap[id=${section.id}] .landing-data-components-container`)?.clientWidth || 900
        const marginRightMarginLeft = 0
        const clWidth = getCssDemention( width - cw * props.data.length - marginRightMarginLeft )
        setClWdt( clWidth )
        setWdt( width )
        addCSSClass(
            `section-haccordeon-container-${section.id}`,
            `.section-haccordeon-container-${section.id} {
                ${setHorizontalAlignToCSSRule(section.vertical_align || ALIGN.MIDDLE )};
                height: ${getCssDemention(position.height, "400px")};
                min-height: ${getCssDemention(position.height, "400px")};
                flex-direction: row; 
                .haccordeon-card-cover-container {
                    ${ CSSObjectToString( section.haccordeon_design?.card || {} ) }
                    ${ cover_width }
                }
                .haccordeon-card-cover {
                    ${ CSSObjectToString( section.haccordeon_design?.card_cover || {} ) } 
                    ${ cover_width }
                }
                .landing-haccordeon-card-container .haccordeon-card-content-container {
                    transition: all 0.5s ease-out!important;
                    width: 0!important;
                    overflow: hidden; 
                    .landing-section-data-animation,
                    .landing-section-data-position,
                    .landing-content-container {
                        width: 100%
                    } 
                }
                .landing-haccordeon-card-container.open .haccordeon-card-content-container {
                    width: ${ clWidth }!important;
                    cursor:pointer;
                }
                .haccordeon-card-content-container > div > div > .landing-content-container {
                    padding: 0 20px;
                    min-width: ${ clWidth }!important;
                    max-width: ${ clWidth }!important;
                    width: ${ clWidth }!important;
                }
                .haccordeon-card-icon {
                    ${ CSSObjectToString( section.haccordeon_design?.card_icon || {}, true ) } 
                    font-size: ${section.haccordeon_design?.icon_size ? section.haccordeon_design.icon_size : 32}px!important;
                } 
                .haccordeon-card-title-container {
                    ${ CSSObjectToString( section.haccordeon_design?.card_label || {}, true ) } 
                    font-size: ${section.haccordeon_design?.label_size ? section.haccordeon_design.label_size : 14}px!important;
                    ${ 
                        section.haccordeon_design?.isOrder 
                            ? 
                            `
                            top:0!important;
                            text-align: center;
                            ` 
                            : 
                            `
                            min-width:${getCssDemention( position.height - 130, "380px")};  
                            text-align: right!important; 
                            transform: translateY(-300px) rotate(-90deg) !important;` 
                    }
                }
            }`
        )
        setAccOpen( section.data[0]?.id)
        return () => {
            removeCSSClass( `section-haccordeon-container-${section.id}` )
        }
    }, [ section ])
    
    return <div 
        className={`landing-data-components-container  landing-section-haccordeon ${section.className || ""} landing-edit-cont section-haccordeon-container-${props.section.id}`}
        style={{...section.dstyle, }} 
        data-proportia={composition.proportia.join(",")}
    >
       {
            props.data.map((data, i) => {  
                return <Fragment key={ data.id }>
                    <HAccordeonSection
                        section={ section }
                        data={ data }
                        i={ i }
                        isOpen={ data.id === accOpen }
                        setOpen={ () => setAccOpen( data.id ) }
                        color={ cardsColor[ i ] }
                        isOrder={!!section.haccordeon_design?.isOrder}
                    /> 
                </Fragment>
            })
        }
    </div>
}
export default SectionHAccordeon